import { assignModule } from '@blocks/base/store';
import user from '@blocks/user/module';
import { inviteFriend } from '@this/services/user';
const state = {
  mid: 0,

};

const mutations = {
  setMID(state, str) {
    state.mid = str;
  },
};

const actions = {
  // 事件
  authBefore({ dispatch }, to) {
    const {
      query: { mid },
    } = to;
    dispatch('setValue', { key: 'mid', mutation: 'setMID', value: mid });
  },
  inviteFriend({ state }) {
    const { mid } = state;
    if (!mid) return;
    return inviteFriend({
      mid,
    });
  },
};

export default assignModule(user, {
  state,
  mutations,
  actions,
});
